import { Controller } from '@hotwired/stimulus'
import { alertError, alertSuccess } from '../../lib/dialogs.js'

export default class extends Controller {
  static get values() {
    return {
      type: String,
      title: String,
      text: String,
    }
  }

  connect() {
    if (this.textValue || this.titleValue) {
      ;['error', 'alert'].includes(this.typeValue)
        ? alertError(this.titleValue, this.textValue)
        : alertSuccess(this.titleValue, this.textValue)
    }
  }
}
